module.exports = __webpack_public_path__ + "img/left.cdae6293.svg";